import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M46 14h-5V7c0-1.65-1.35-3-3-3H12c-1.65 0-3 1.35-3 3v7H4c-2.21 0-4 1.79-4 4v16c0 2.21 1.79 4 4 4h5v5c0 1.65 1.35 3 3 3h26c1.65 0 3-1.35 3-3v-5h5c2.21 0 4-1.79 4-4V18c0-2.21-1.79-4-4-4M11 7c0-.55.45-1 1-1h26c.55 0 1 .45 1 1v7H11zm28 36c0 .55-.45 1-1 1H12c-.55 0-1-.45-1-1V30h28zm9-9c0 1.1-.9 2-2 2h-5v-6c0-1.1-.9-2-2-2H11c-1.1 0-2 .9-2 2v6H4c-1.1 0-2-.9-2-2V18c0-1.1.9-2 2-2h42c1.1 0 2 .9 2 2z",
      style: {"fill":"#999","stroke-width":"0"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M16 36h18c.55 0 1-.45 1-1s-.45-1-1-1H16c-.55 0-1 .45-1 1s.45 1 1 1",
      style: {"fill":"#999","stroke-width":"0"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M16 40h13c.55 0 1-.45 1-1s-.45-1-1-1H16c-.55 0-1 .45-1 1s.45 1 1 1",
      style: {"fill":"#999","stroke-width":"0"}
    }, null, -1),
    _createElementVNode("circle", {
      cx: "39",
      cy: "22",
      r: "2",
      style: {"fill":"#999","stroke-width":"0"}
    }, null, -1)
  ])))
}
export default { render: render }